export var EnumPurchaseEventLsListenedProps;
(function (EnumPurchaseEventLsListenedProps) {
  EnumPurchaseEventLsListenedProps["LS_LISTENER_IS_ON_PROP"] = "LS_LISTENER_IS_ON_PROP__GRM";
  EnumPurchaseEventLsListenedProps["GAME_PURCHASE_REQUEST"] = "LS_LISTENING_GAME_PURCHASE_REQUEST__GRM";
  EnumPurchaseEventLsListenedProps["GEMS_PURCHASE_NEW_TAB"] = "LS_LISTENING_GEMS_PURCHASE_FINISHED__GRM";
})(EnumPurchaseEventLsListenedProps || (EnumPurchaseEventLsListenedProps = {}));